import React from 'react'
import { Button } from '@material-ui/core'
import { COLORES } from '../../../../../../config/colores'

function IngresarCamionSinCupo (props) {
  const { numero } = props

  const ingresarCPA = () => {
    props.ingresar(numero)
  }

  return (
    <Button
      size='small'
      variant='outlined'
      style={{ color: COLORES.grey.dark, margin: '8px' }}
      onClick={ingresarCPA}
    >
            Ingresar
    </Button>
  )
}

export default IngresarCamionSinCupo
